export enum LoginScope {
  'BACKOFFICE' = 'BACKOFFICE',
  'MOBILE_APP' = 'MOBILE_APP',
  'DRIVER_APP' = 'DRIVER_APP',
}
